import { cssVar, Label, useSizes } from 'metrix-common3';
import styled from 'styled-components';

const BadgeContainer = styled.div`
	background-color: ${cssVar.colorStrokeVeryLight};
	border-radius: 1rem;
	padding: .25rem .75rem .25rem .5rem;
	display: flex;
	gap: .5rem;
	justify-content: center;
	align-items: center;
	line-height: 1rem;
`;

const BadgeCircle = styled.div`
	width: .5rem;
	height: .5rem;
	border-radius: 50%;
	background-color: ${(props) => props.color};
`;

const Badge = (props) => {
    const sizes = useSizes();

    return (
        <BadgeContainer>
            <BadgeCircle color={props.color} />
            <Label text={props.text} size={sizes.sm} />
        </BadgeContainer>
    );
};

export default Badge;
